export function lockScroll() {
    document.body.style.overflow = 'hidden';
}

export function unlockScroll() {
    document.body.style.overflow = '';
}